(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('flyerInfoBox', {
            templateUrl: 'app/admin/flyers/components/flyer-info-box.html',
            controller: flyerInfoBoxController,
            bindings: {
                flyer: '<',
                currencyInstance: '<',
                isImmoContext: '<',
                isHubContext: '<',
                isShowCaseContext: '<',
                isPublished: '<',
                isOnShowCase: '<',
                detailsLayout: '<',
                actions: '<',
                showSortHandle: '<?'
            }
        });

    /** @ngInject */
    function flyerInfoBoxController($scope, $document, $translate, $window, $timeout) {
        var $ctrl = this;

        function updateIsMobile() {
            $ctrl.isMobile = $window.innerWidth <= 768;
        }

        $ctrl.showLeftArrow = false;
        $ctrl.showRightArrow = false;
        $ctrl.showRetailsLeftArrow = false;
        $ctrl.showRetailsRightArrow = false;
        $ctrl.showSortHandle = $ctrl.showSortHandle !== undefined ? $ctrl.showSortHandle : false;

        updateIsMobile();

        angular.element($window).on('resize', function () {
            $scope.$apply(updateIsMobile);
        });

        $ctrl.dateFormat = $translate.instant('dateFormat');

        $ctrl.$onInit = function () {
            if (!$ctrl.currencyInstance) {
                var currencyConfiguration = getCurrencyListConfiguration();
                $ctrl.currencyInstance = currencyConfiguration[$ctrl.flyer.currency];
            }
            getMinMaxDetails();

            $timeout(function () {
                updateScrollArrows('tagsBox-' + $ctrl.flyer.id, 'showLeftArrow', 'showRightArrow');
                updateScrollArrows('retailsBox-' + $ctrl.flyer.id, 'showRetailsLeftArrow', 'showRetailsRightArrow');
            }, 0);
        }

        $ctrl.scrollBox = function (boxId, direction, leftArrowKey, rightArrowKey, $event) {
            if ($event) {
                $event.stopPropagation();
            }

            var boxCompleteId = boxId + "-" + $ctrl.flyer.id;
            var box = $document[0].getElementById(boxCompleteId);
            var scrollAmount = 150;
            if (!box) return;

            box.scrollLeft += direction === 'left' ? -scrollAmount : scrollAmount;

            updateScrollArrows(boxCompleteId, leftArrowKey, rightArrowKey);
        };

        function updateScrollArrows(boxId, leftArrowKey, rightArrowKey) {
            var box = $document[0].getElementById(boxId);
            if (!box) return;

            $ctrl[leftArrowKey] = box.scrollLeft > 0;
            $ctrl[rightArrowKey] = box.scrollLeft + box.clientWidth < box.scrollWidth;

            $scope.$applyAsync();
        }

        function getMinMax(details, keys) {
            var values = [];

            for (var i = 0; i < details.length; i++) {
                if (angular.isArray(keys)) {
                    for (var j = 0; j < keys.length; j++) {
                        var key = keys[j];
                        var value = details[i][key];

                        if (value !== undefined && value !== null) {
                            if ((key === 'purchaseValue' || key === 'discountedValue') && Number(value) <= 0) {
                                continue;
                            }
                            values.push(value);
                        }
                    }
                } else {
                    var v = details[i][keys];
                    if (v !== undefined && v !== null) {
                        values.push(v);
                    }
                }
            }

            return values.length > 0
                ? [Math.min.apply(null, values), Math.max.apply(null, values)]
                : [null, null];
        }

        function getMinMaxDetails() {
            if (!$ctrl.flyer.details || $ctrl.flyer.details.length === 0) {
                $ctrl.hasDetails = false;
                return;
            }

            $ctrl.hasDetails = true;
            var details = $ctrl.flyer.details;
            $ctrl.singleItem = details.length === 1;

            var properties = ['meters', 'bathroom', 'bedroom', 'parking', 'purchaseValue'];

            properties.forEach(function (property) {
                var minMax = getMinMax(details, property);
                $ctrl['min' + property.charAt(0).toUpperCase() + property.slice(1)] = minMax[0];
                $ctrl['max' + property.charAt(0).toUpperCase() + property.slice(1)] = minMax[1];
            });

            if (!$ctrl.isImmoContext) {
                var minMax = getMinMax(details, ['purchaseValue', 'discountedValue']);
                $ctrl['minPurchaseValue'] = minMax[0];
                $ctrl['maxPurchaseValue'] = minMax[1];
            }

            if ($ctrl.singleItem) {
                var item = details[0];
                properties.forEach(function (property) {
                    $ctrl['min' + property.charAt(0).toUpperCase() + property.slice(1)] =
                        $ctrl['max' + property.charAt(0).toUpperCase() + property.slice(1)] =
                            item[property] !== undefined && item[property] !== null ? item[property] : null;
                });
            }

            var min = $ctrl.minPurchaseValue;
            var max = $ctrl.maxPurchaseValue;

            $ctrl.shouldShowSingleValue =
                $ctrl.singleItem ||
                (min !== null && min !== undefined && max !== null && max !== undefined &&
                    Number(min).toFixed(2) === Number(max).toFixed(2));
        }
    }
})();
